import React from 'react';
import { PaymentPlansLocalePath } from '../i18n/PaymentPlansLocale';
import PostInstallmentItem from './PostInstallmentItem';
import { Tables } from '../../../../Components';
import { useTranslation } from 'react-i18next';
import { TableActions } from '../../../../Enums';
import { actionTypes } from '../constants';
import moment from 'moment';
function formatMonth(count, duration = 'month') {
  const pluralRules = new Intl.PluralRules('en');
  const pluralForm = pluralRules.select(count);
  const suffix = pluralForm === 'one' ? duration : duration + 's';
  return suffix;
}
const PostHandoverInstallments = ({ installments, dispatch }) => {
  const { t } = useTranslation(PaymentPlansLocalePath);
  const onActionClicked = (_enumKey, item) => {
    dispatch({
      value: item.id,
      action: actionTypes.REMOVE,
      nestedField: 'id',
      field: 'postHandoverInstallment',
    });
  };
  return (
    <div className='p-3 flex gap-1 flex-col'>
      <PostInstallmentItem dispatch={dispatch} />
      <Tables
        headerData={[
          {
            label: 'installment %',
            input: 'amountPercentage',
            component: (row) => `${row.amountPercentage * 100}%`,
          },
          {
            label: 'trigger_type',
            input: 'frequencyValue',
            component: (row) => {
              if (row.numberOfInstallment) {
                return t('by_month');
              } else if (row.frequencyName?.toLowerCase() === 'date') {
                return t('by_fixed_date');
              } else {
                return t('by_duration');
              }
            },
          },
          {
            label: 'trigger_value',
            input: 'frequencyValue',
            component: (row) => {
              if (row.numberOfInstallment) {
                return `Every ${row.frequencyValue} ${t(
                  formatMonth(+row.frequencyValue)
                )}`;
              } else if (row.frequencyName.toLowerCase() === 'date') {
                return moment(row.frequencyValue).format('DD-MMM-YYYY');
              } else {
                return `in ${row.frequencyValue} ${formatMonth(
                  row.frequencyValue,
                  row.frequencyName.toLowerCase()
                )}`;
              }
            },
          },
          { label: 'number_of_installment', input: 'numberOfInstallment' },
        ]}
        data={installments}
        bodyRowId={'postHandover-installment'}
        defaultActions={[{ enum: TableActions.delete.key }]}
        activePage={1}
        actionsOptions={{ onActionClicked }}
        parentTranslationPath={PaymentPlansLocalePath}
        itemsPerPage={installments.length}
      />
    </div>
  );
};

export default PostHandoverInstallments;
